module.exports = __webpack_public_path__ + "static/media/schwab.aa183f52.jpg";